import {ToolbarItem} from './types'

export const defaultToolbar: ToolbarItem[] = [
  'heading',
  'customFontFamily',
  'customFontSize',
  'fontColor',
  'fontBackgroundColor',
  'alignment',
  'bold',
  'italic',
  'strikethrough',
  'superscript',
  'removeFormat',
  'link',
  'mediaEmbed',
  'imageUpload',
  'htmlEmbed',
  'bulletedList',
  'numberedList',
  'outdent',
  'indent',
  'blockQuote',
  'insertTable',
  'customTheme',
]
